import {
  Firestore,
  doc,
} from 'firebase/firestore';

/**
 * One floor layout doc per team placement (teamplacement bucket), scoped to the session only.
 * Path: sessions/{sessionId}/floorLayout/{encodedTeamKey} — shared by all users on that session, never per-user.
 */
export function encodeTeamKeyForFloorLayoutDoc(teamKey: string): string {
  return encodeURIComponent(teamKey);
}

export function floorLayoutDocumentRef(db: Firestore, sessionId: string, teamKey: string) {
  const id = encodeTeamKeyForFloorLayoutDoc(teamKey);
  return doc(db, 'sessions', sessionId, 'floorLayout', id);
}

function clampPct(n: number): number {
  return Math.min(100, Math.max(0, n));
}

export function normalizePlacementValue(raw: unknown): { xPct: number; yPct: number } | null {
  if (!raw || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  const x = Number(o.xPct);
  const y = Number(o.yPct);
  if (!Number.isFinite(x) || !Number.isFinite(y)) return null;
  return { xPct: clampPct(x), yPct: clampPct(y) };
}

/** Parse Firestore `placements` map into a clean record (athleteId → position). */
export function placementsFromFirestoreData(data: unknown): Record<string, { xPct: number; yPct: number }> {
  if (!data || typeof data !== 'object') return {};
  const src = data as Record<string, unknown>;
  const out: Record<string, { xPct: number; yPct: number }> = {};
  for (const [athleteId, raw] of Object.entries(src)) {
    const pos = normalizePlacementValue(raw);
    if (pos) out[athleteId] = pos;
  }
  return out;
}
